import { Flex, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getContract, readContract } from "thirdweb";
import ERC20_ABI from './erc20_abi.json'
import { utils } from "ethers";

export function CheckAllowance({
  airdropContractAddress,
  contractAddress,
  setNeedsApproval,
  setIsCheckingAllowance,
  total,
  symbol,
  count,
  walletAddress,
  client,
  chain,
  setAllowanceAmount,
  setRawAllowanceAmount,
  setRequiredAmount,
  setAllowanceVerified
}: {
  airdropContractAddress: string,
  contractAddress: string,
  setNeedsApproval: (value: boolean) => void,
  setIsCheckingAllowance: (value: boolean) => void,
  total: number,
  symbol: string,
  count: number,
  walletAddress: string,
  client: any,
  chain: any,
  setAllowanceAmount: (value: number) => void,
  setRawAllowanceAmount: (value: number) => void,
  setRequiredAmount: (value: number) => void,
  setAllowanceVerified: (value: boolean) => void,
}) {

  const [allowance, setAllowance] = useState(0);
  const [decimals, setDecimals] = useState(6);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingDecimals, setIsLoadingDecimals] = useState(true);

  const fetchAllowance = async () => {
    setIsLoading(true);
    setIsLoadingDecimals(true);
    setIsCheckingAllowance(true)
    try {
      const contract = getContract({
        client,
        address: contractAddress,
        chain: chain,
        abi: ERC20_ABI,
      });

      const tokenDecimals = await readContract({
        contract,
        method: "decimals",
        params: [],
      });

      const rawAllowance = await readContract({
        contract,
        method: "allowance",
        params: [walletAddress, airdropContractAddress],
      });
      
      const requiredAmount = BigInt(Math.floor(total * 10 ** tokenDecimals));
      setRequiredAmount(requiredAmount)
      if (rawAllowance >= requiredAmount) {
        console.log("Allowance suficiente");
      } else {
        console.log("Falta aprobar más");
      }


      // const formattedAllowance = Number(rawAllowance) / Math.pow(10, tokenDecimals);
      const formattedAllowance = utils.formatUnits(rawAllowance, tokenDecimals);
      setAllowance(Number(formattedAllowance));
      setAllowanceAmount(Number(formattedAllowance));
      setRawAllowanceAmount(rawAllowance);
      setDecimals(tokenDecimals);
      setAllowanceVerified(true);

      console.log('ALLOWANCE RAWWWWWW:', rawAllowance, Number(rawAllowance));
      console.log('ALLOWANCE VERIFICATION:');
      console.log('ALLOWANCE amount:', formattedAllowance);
      console.log('total amount to pay:', total);
      //console.log('needs approval ?', allowance < total, Number(formattedAllowance) < total);
      console.log('needs approval ?', rawAllowance < requiredAmount);
      console.log('NEEEEEEDDD ?', rawAllowance, requiredAmount);
      

      //setNeedsApproval(Number(formattedAllowance) < total)
      setNeedsApproval(rawAllowance < requiredAmount)
    } catch (error) {
      console.error("Error obteniendo allowance:", error);
    } finally {
      setIsLoading(false);
      setIsLoadingDecimals(false);
      setIsCheckingAllowance(false)
      setAllowanceVerified(false);
    }
  };

  useEffect(() => {
    fetchAllowance();
  }, [walletAddress]);

  useEffect(() => {
    count > 0 && fetchAllowance();
  }, [count]);

  return (
    <Flex w='full' fontSize={'18px'}>
      <Flex>Allowance:</Flex>
      <Flex ml='auto' fontWeight={'700'}>
        {(isLoading && isLoadingDecimals) ? <Spinner w='22px' h='22px' color='white' /> : <>{allowance?.toString()} {symbol}</>}
      </Flex>
    </Flex>
  );
}